import { useEffect, useState } from "react";
import { getAdvertising, postAdvertisingClick } from "services/AdvertisingService";
import placeholder from "images/placeholder-large-dark.png";

const Advertising = ({
  categoryId = null,
  subCategoryId = null,
  type = 'vertical', // horizontal, vertical, large
  defaultRadar = false,
  onlyShowOnHome = false,
}: any) => {

  const [loading, setLoading] = useState(false);
  const [banner, setBanner] = useState(null);
  const [hidden, setHidden] = useState(false);
  const base_url = process.env.REACT_APP_BACKEND_API_URL + '/storage/images/posts/banners';

  useEffect(() => {

    // pega a medica da tela, para ver se é mobile
    const isMobile = window.innerWidth < 768;

    if (isMobile && type == 'horizontal') {
      setHidden(true);
      return;
    }

    fetchData();
    
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const filters = {
        category_id: categoryId,
        sub_category_id: subCategoryId,
        type: type,
        default_radar: defaultRadar,
        only_show_on_home: onlyShowOnHome,
      };

      const response = await getAdvertising(filters);

      // response esta vindo assim {} devo impedir que o componente seja renderizado
      if (Object.keys(response).length === 0) {
        setBanner(null);
      } else {
        setBanner(response);
      }

      setLoading(false);
    } catch (error) {
      // toast.error("Erro ao carregar os dados");
    }
  };

  const getUrl = (url: string) => {
    if (!url) {
      return '#';
    }

    if (url.includes('http')) {
      return url;
    }

    return 'https://' + url;
  }

  const handleClick = async (banner: any) => {
    const url = getUrl(banner.url);
    window.open(url, '_blank');

    await postAdvertisingClick(banner.id);
  }

  return (
    <>
      {
        !hidden && (
          <>
            {
              loading ? (
                <div className="flex justify-center items-center w-full lg:w-[400px] h-[16rem] lg:h-auto bg-gray-300" style={{ borderRadius: '0px' }}>
                  {/* Placeholder enquanto o anúncio carrega */}
                </div>
              ) : (
                <>
                  {
                    banner && (
                      <>
                        {
                          type === 'large' ? (
                            <a className="cursor-pointer" onClick={() => handleClick(banner)} rel="noreferrer">
                              <img className="w-full h-auto" src={base_url + '/large/' + banner?.banner_large_path} alt="banner" />
                            </a>
                          ) : (
                            <>
                              {
                                type === 'vertical' ? (
                                  <a className="cursor-pointer" onClick={() => handleClick(banner)} rel="noreferrer">
                                    <div className="flex justify-center items-center w-full lg:w-[400px]">
                                      <img 
                                        className="w-full h-auto" 
                                        src={base_url + '/vertical/' + banner?.banner_vertical_path} 
                                        alt="banner" 
                                        onError={(e) => (e.currentTarget.src = placeholder)}
                                      />
                                    </div>
                                  </a>
                                ) : (
                                  <a className="cursor-pointer" onClick={() => handleClick(banner)} rel="noreferrer">
                                    <img className="w-full h-auto" src={base_url + '/horizontal/' + banner?.banner_horizontal_path} alt="banner" />
                                  </a>
                                )
                              }
                            </>
                          )
                        }
                      </>
                    )
                  }
                </>
              )
            }
          </>
        )
      }
    </>
  );
};

export default Advertising;